import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import { useDropzone } from "react-dropzone";
import { Box, Grid, Typography, FormHelperText } from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import Controls from "../controls";

import ConfirmDialog from "../ConfirmDialog";

import FileBlockContent from "./FileBlockContent";

const DropZoneStyle = {
  outline: "none",
  padding: "20px 10px",
  borderRadius: "10px",
  backgroundColor: "#ffffff",
  border: "1px dashed #919EAB",
  cursor: "pointer",
};

export default function UploadContractForm(props) {
  const { addOrEdit } = props;
  const { watch, control, errors, setValue, handleSubmit } = useForm();

  const fileToUpload = watch("file");

  const onDrop = useCallback(
    (files) => {
      const file = files && files.length ? files[0] : null;
      if (file) {
        setValue("file", file);
      }
    },
    [setValue]
  );

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      "image/jpeg": [".jpg", ".jpeg"],
      "image/png": [".png"],
      "application/pdf": [".pdf"],
    },
    onDrop,
  });

  const onSubmit = (data) => {
    setConfirmDialog({
      isOpen: true,
      title: "Additionally, would you like to create an invoice for this quote?",
      onConfirm: () =>  onSaveData(data, true),
      onCancelAction: () =>  onSaveData(data, false),
    });
 
  };


  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const onSaveData = (data, createInvoice) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });

    addOrEdit(data, createInvoice);
  };


  

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid
          container
          spacing={5}
          style={{
            justifyContent: "center",
            alignItems: "center",
            padding: 10,
          }}
        >
          <Grid item xs={12} lg={12}>
            <Controller
              name="name"
              control={control}
              defaultValue={`Contract-${moment().format("YYYY-MM-DD")}`}
              render={({ onChange, value }) => (
                <Controls.Input
                  label="Name"
                  fullWidth
                  onChange={onChange}
                  value={value}
                />
              )}
              rules={{ required: "Contract name is required" }}
            />

            <FormHelperText id="name-helper-text">
              <Typography style={{ color: "red" }}>
                {errors.name ? errors.name.message : " "}
              </Typography>
            </FormHelperText>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Controller
              name="file"
              control={control}
              defaultValue=""
              render={({ onChange, value }) => (
                <Box style={{ width: "100%" }}>
                  <Box {...getRootProps()} style={DropZoneStyle}>
                    <input {...getInputProps()} />
                    <FileBlockContent
                      iconSelect="solar:document-broken"
                      file={fileToUpload}
                      title={
                        <Typography gutterBottom variant="h5">
                          Drop or select a file
                        </Typography>
                      }
                      subtitle={
                        <>
                          <Typography
                            variant="subtitle2"
                            style={{ color: "text.secondary", marginLeft: 15 }}
                          >
                            *** Drop files here or click&nbsp;
                            <Typography
                              variant="subtitle2"
                              component="span"
                              style={{
                                color: "primary.main",
                                textDecoration: "underline",
                              }}
                            >
                              browse
                            </Typography>
                            &nbsp;thorough your machine ***
                          </Typography>
                          <Typography
                            variant="body2"
                            style={{
                              color: "text.secondary",
                              fontStyle: "italic",
                            }}
                          >
                            *** Supported file formats: JPG, JPEG, PNG, and PDF
                            ***
                          </Typography>
                        </>
                      }
                    />
                  </Box>
                </Box>
              )}
              rules={{ required: "File is required" }}
            />
            <FormHelperText>
              <Typography style={{ color: "red", textAlign: "center" }}>
                {errors.file ? errors.file.message : " "}
              </Typography>
            </FormHelperText>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            justifyContent: "flex-end",
            alignItems: "center",
            marginTop: 15,
          }}
        >
          <Grid item xs={2}>
            <Controls.Button type="submit" text="Submit" />
          </Grid>
        </Grid>
      </form>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </>
  );
}
